var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-invalid-feedback',{attrs:{"state":_vm.state}},[(_vm.text !== '')?_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.$t('fieldobligatory'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }